import React, { Component } from 'react';

class AcmPushCaseConfirmModal extends Component {
  render() {
    const { onPushCaseYes, onPushCaseNo } = this.props;

    return (
      <div
        className="modal fade theme-modal"
        id="acmPushCaseConfirmModal"
        tabIndex="-1"
        aria-labelledby="acmPushCaseConfirmModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-body">
              <p>
                This case will be pushed to ACM for AI predictions and/or templating.
                Only DICOM files are accepted by ACM. <br />
                Are you sure you want to continue?
              </p>
            </div>
            <div className="modal-footer">
              <div className="row gx-2">
                <div className="col-6">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal" onClick={() => onPushCaseNo()}>
                    No
                  </button>
                </div>
                <div className="col-6">
                  <button type="button" className="btn btn-gray w-100" data-bs-dismiss="modal" onClick={() => onPushCaseYes()}>
                    Yes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AcmPushCaseConfirmModal;
